import { BasicComponent } from "haxt";

import "./MemberArea.scss";
import { Session } from "../../@noxtum/session/Session";
import { RouterLink } from "../../@noxtum/router/RouterLink";
import { Router } from "../../@noxtum/router/Router";

export class MemberArea extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	public render() {
		let loggedIn = Session.isLoggedIn();

		if (!loggedIn) {
			return (
				<div class="MemberArea">
					<h1>Access Denied</h1>
					<p>You must be logged in to access the member area.</p>
					<RouterLink href="/members/login" query={{ return: window.location.pathname + window.location.search }}>Go to Login</RouterLink>
				</div>
			);
		}

		return (
			<div class="MemberArea">
				<h1>Member Area Page</h1>
				<div>
					<p>Welcome to the member area. More features coming soon!</p>
				</div>
				<button class="btn" type="button" onClick={() => {
					Session.clearToken();
					Router.navigate("/");
				}}>Logout</button>
			</div>
		);
	}
}
